export function getCookie(name) {
  if (process.env.REACT_APP_ENVIRONMENT === "development") {
    return "Bearer eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS5kZXYubWF3YWxvZy5jb20vYWNjb3VudHMvbG9naW5faHR0cG9ubHkiLCJpYXQiOjE3OTE5OTU5MDAsImV4cCI6MTc5MjA4MjMwMCwibmJmIjoxNzkxOTk1OTAwLCJqdGkiOiJ6MGFBdDhvT0VxZ1RCNVI4Iiwic3ViIjoiMSIsInBydiI6IjlhZDU4NTc3ZmFiNmZiYzE1NTQzNGQzNTkxZWRmMTY0YTE3NzY1YWEiLCJhdXRoaWQiOjEsIm9yZ2lkIjoiMzQ0Y2MxZGEtMzIxYS00YThmLTgxNmMtNGRkZmVhMjYyNzVmIiwidXNlcmlkIjoxLCJkYXRhYmFzZW5hbWUiOiJkZXYiLCJvcmdfY29kZSI6ImRldiIsInRpbWV6b25lIjoiICsgaW50ZXJ2YWwgJzA1IGhvdXJzIDMwIG1pbnV0ZXMnIiwicm9sZWlkIjoiZGFjZjc5YWYtYWViMi00YjRmLWJjNDYtZmM5ODY5ODNlNTlmIiwicGF5bWVudF9zdGF0dXMiOnRydWUsImF1dGhvcml0aWVzIjpbIlJPTEVfVVNFUiJdLCJkZXZpY2VfaWQiOiIzZmI4N2I5OS1iNDI5LTQyYjUtYmMxOC01MWZlYjRjZmQzODQifQ.usYuZDhMYRJoIS8i739ey56UdCVcuMU83QE_hQrScxM";
  }
  const accountsUrl = process.env.REACT_APP_ACCOUNTS_URL;
  const cookieString = document.cookie;
  const cookies = cookieString.split(";");

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim(); // Remove leading spaces
    if (cookie.startsWith(name + "=")) {
      if (cookie.substring(name.length + 1) === "") {
        const currentURL = window.location.href;

        const redirectData = {
          redirectPath: currentURL,
          app: "tickgo",
          ts: Date.now(),
        };

        console.warn("🔐 Saving redirect in window.name:", redirectData);

        // ✅ TAB-SPECIFIC, CROSS-DOMAIN SAFE
        window.name = JSON.stringify(redirectData);
        window.location.href = `${accountsUrl}/login`;
      }
      return cookie.substring(name.length + 1); // Return the value of the cookie
    }
  }
  document.cookie =
    "redirectPath=" + window.location.href + "; path=/; domain=.mawalog.com";
  document.cookie = "mawalog=; path=/; domain=.mawalog.com";
  window.location.href = accountsUrl;
  return null; // Return null if the cookie is not found
}
